import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconPoints = ({ color = petrol.main, fill = 'none', ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        className="lucide lucide-coins"
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8" cy="8" fill="none" r="6" />
        <path d="M18.09 10.37A6 6 0 1 1 10.34 18" fill="none" />
        <path d="M7 6h1v4" fill="none" />
        <path d="m16.71 13.88.7.71-2.82 2.82" fill="none" />
      </svg>
    </SvgIcon>
  );
};

export default IconPoints;
